<metric-mapping-dialog
  [dialogData]="data"
  [campaigns]="salesforceCampaignsList"
  [placeholderText]="placeholderText"
  (saveMappingState)="onSave($event)"
  (closeClick)="dialogRef.close()"
></metric-mapping-dialog>
